import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { clearAuthData } from "@/helpers/clearAuthData"
import { useModal } from "@/modals"
import { useAppDispatch, useAppSelector } from "@/store"
import { AppSelectors } from "@/store/slices/app"
import { setIsAuthorized } from "@/store/slices/player"
import { Button } from "@/ui/Button"
import { Modal } from "@/ui/Modal"
import { OutlinedText } from "@/ui/OutlinedText"
import styles from "./SettingsModal.module.scss"
import { LanguageSwitcher } from "./ui"

const modalType = "settings"

export const SettingsModal: FC = () => {
  const dispatch = useAppDispatch()
  const { modal, getModalParams } = useModal(modalType)
  const { t } = useTranslation()

  const isTMA = useAppSelector(AppSelectors.selectIsTMA())

  const params = getModalParams(modalType)

  const handleBack = () => {
    params?.onBack?.()
    modal.close()
  }

  const handleClose = () => {
    modal.close()
  }

  const handleLogout = () => {
    clearAuthData()
    dispatch(setIsAuthorized(false))
  }

  return (
    <Modal.Center
      type={modalType}
      className={clsx(styles.SettingsModal)}
      body={{ className: styles.SettingsModal_body }}
    >
      <div className={styles.SettingsModal_container}>
        <div className={clsx(styles.SettingsModal_content)}>
          <OutlinedText className={clsx(styles.SettingsModal_title)}>
            {t("settings.title")}
          </OutlinedText>
          <LanguageSwitcher
            className={clsx(styles.SettingsModal_languageSwitcher)}
          />
          {!isTMA && (
            <Button
              className={clsx(styles.SettingsModal_logoutButton)}
              onClick={handleLogout}
            >
              {t("settings.logout")}
            </Button>
          )}
        </div>
        <div className={clsx(styles.SettingsModal_footerButtons)}>
          {params?.onBack ? (
            <Button
              className={clsx(styles.SettingsModal_footerButtons_item)}
              styles="green"
              onClick={handleBack}
            >
              {t("settings.back")}
            </Button>
          ) : (
            <Button
              className={clsx(styles.SettingsModal_footerButtons_item)}
              styles="green"
              onClick={handleClose}
            >
              {t("settings.close")}
            </Button>
          )}
        </div>
      </div>
    </Modal.Center>
  )
}
